import { render, staticRenderFns } from "./normalCourse.html?vue&type=template&id=38a84991&scoped=true&external"
import script from "./normalCourse.vue?vue&type=script&lang=js"
export * from "./normalCourse.vue?vue&type=script&lang=js"
import style0 from "./normalCourse.css?vue&type=style&index=0&id=38a84991&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a84991",
  null
  
)

export default component.exports